import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "kanban-col inbox-col"
}
const _hoisted_2 = { class: "kanban-colh" }
const _hoisted_3 = { class: "kanban-colcnt" }
const _hoisted_4 = { class: "kanban-colb" }
const _hoisted_5 = {
  key: 0,
  class: "inbox-col-hint"
}
const _hoisted_6 = {
  key: 0,
  class: "inbox-col-hint"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "crm-board-item-body" }
const _hoisted_11 = {
  key: 0,
  class: "customer-request-tags"
}
const _hoisted_12 = { class: "customer-request-tags crm-extra-tags" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { key: 4 }
const _hoisted_17 = ["title"]
const _hoisted_18 = ["title"]
const _hoisted_19 = {
  key: 1,
  class: "inbox-col-empty"
}
const _hoisted_20 = { class: "inbox-rk-head" }
const _hoisted_21 = { class: "kanban-colcnt" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "inbox-rk-name" }
const _hoisted_24 = { class: "inbox-rk-meta" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 0,
  class: "inbox-col-empty"
}
const _hoisted_28 = {
  key: 0,
  class: "error-msg-wrap"
}
const _hoisted_29 = { class: "form-wrapper slide-up crm-form-wrapper crm-form-new" }
const _hoisted_30 = { class: "form-close" }
const _hoisted_31 = { class: "qc-item-wrap crm-item-wrap crm-item-wrap-bare" }
const _hoisted_32 = { class: "inbox-rk-popup-name" }
const _hoisted_33 = { class: "inbox-rk-meta" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "inbox-move-row" }
const _hoisted_37 = ["value"]
const _hoisted_38 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_ctx.collapsed)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "kanban-col kanban-col-collapsed inbox-col inbox-col-collapsed",
        title: "Show inbox",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCollapsed(false)))
      }, [
        _createVNode(_component_svg_icon, {
          icon: "arrowsout",
          class: "kanban-colcollapse"
        }),
        _createElementVNode("span", null, "Inbox (" + _toDisplayString(_ctx.items.length) + ")", 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_svg_icon, {
            icon: "inbox",
            class: "inbox-col-icon"
          }),
          _cache[5] || (_cache[5] = _createElementVNode("span", null, "Inbox", -1)),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.items.length), 1),
          _createVNode(_component_svg_icon, {
            icon: "arrowsin",
            class: "kanban-colcollapse",
            title: "Collapse inbox",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCollapsed(true)))
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.loaded && !_ctx.hasEmployee)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Your inbox needs a Team Hub employee record linked to your account."))
            : (_ctx.loaded)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.number)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _cache[6] || (_cache[6] = _createTextVNode("Text ", -1)),
                        _createElementVNode("a", {
                          href: 'sms:' + _ctx.number
                        }, _toDisplayString(_ctx.formatPhone(_ctx.number)), 9, _hoisted_7),
                        _cache[7] || (_cache[7] = _createTextVNode(" to add to your inbox. The first line is the title.", -1))
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_draggable, {
                    class: "crm-board-cards inbox-col-cards",
                    list: _ctx.items,
                    group: { name: 'column', pull: true, put: true },
                    sort: false,
                    onChange: _ctx.dropped,
                    animation: 150,
                    "ghost-class": "kanban-ghost",
                    "empty-insert-threshold": 40,
                    "force-auto-scroll-fallback": true,
                    "scroll-sensitivity": 120,
                    "scroll-speed": 20,
                    delay: 200,
                    "delay-on-touch-only": true,
                    "touch-start-threshold": 5
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'inbox' + item.ID,
                          class: _normalizeClass(["crm-board-card", item.Overdue ? 'crm-board-item-overdue' : '']),
                          onClick: ($event: any) => (_ctx.$emit('open', item))
                        }, [
                          (_ctx.covers[item.ID])
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "inbox-card-cover",
                                src: _ctx.fileUrl(_ctx.covers[item.ID]),
                                alt: "",
                                loading: "lazy"
                              }, null, 8, _hoisted_9))
                            : (item.CardColor)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "item-card-color-cover",
                                  style: _normalizeStyle('background:' + item.CardColor)
                                }, null, 4))
                              : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("h3", null, _toDisplayString(item.Name), 1),
                            (item.TagsJSON.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.TagsJSON, (tag, k) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: k,
                                      style: _normalizeStyle('background:' + _ctx.tagColor(item, tag))
                                    }, _toDisplayString(tag), 5))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_12, [
                              (item.TextedByEmployeeID)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createVNode(_component_svg_icon, { icon: "comment" }),
                                    _cache[8] || (_cache[8] = _createTextVNode("Texted", -1))
                                  ]))
                                : _createCommentVNode("", true),
                              (item.DateDisplay)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(item.Overdue ? 'crm-extra-tag-overdue' : 'crm-extra-tag-date')
                                  }, [
                                    _createVNode(_component_svg_icon, { icon: "clock" }),
                                    _createTextVNode(_toDisplayString(item.DateDisplay), 1)
                                  ], 2))
                                : _createCommentVNode("", true),
                              (item.CommentCount != '0')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createVNode(_component_svg_icon, { icon: "comment" }),
                                    _createTextVNode(_toDisplayString(item.CommentCount), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (item.FileCount != '0')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createVNode(_component_svg_icon, { icon: "paperclip" }),
                                    _createTextVNode(_toDisplayString(item.FileCount), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (item.TotalChecklistItems)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createVNode(_component_svg_icon, { icon: "checkbox" }),
                                    _createTextVNode(_toDisplayString(item.CheckedChecklistItems) + " / " + _toDisplayString(item.TotalChecklistItems), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (item.HomeBoard)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 5,
                                    title: 'Mirrored from ' + item.HomeBoard.Name
                                  }, [
                                    _createVNode(_component_svg_icon, { icon: "copy" }),
                                    _createTextVNode(_toDisplayString(item.HomeBoard.Name), 1)
                                  ], 8, _hoisted_17))
                                : (item.MirrorBoards.length)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 6,
                                      title: 'Also on ' + item.MirrorBoards.map((b) => b.Name).join(', ')
                                    }, [
                                      _createVNode(_component_svg_icon, { icon: "copy" }),
                                      _createTextVNode(_toDisplayString(item.MirrorBoards.length), 1)
                                    ], 8, _hoisted_18))
                                  : _createCommentVNode("", true)
                            ])
                          ])
                        ], 10, _hoisted_8))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["list", "onChange"]),
                  (!_ctx.items.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Nothing in your inbox. Drag a card here to park it."))
                    : _createCommentVNode("", true),
                  (_ctx.showRocks && _ctx.rocksLoaded)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", _hoisted_20, [
                          _cache[9] || (_cache[9] = _createElementVNode("span", null, "Rocks", -1)),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.rocks.length), 1)
                        ]),
                        _createVNode(_component_draggable, {
                          list: _ctx.rocks,
                          group: { name: 'column', pull: true, put: false },
                          sort: false,
                          "force-auto-scroll-fallback": true,
                          "scroll-sensitivity": 120,
                          "scroll-speed": 20,
                          delay: 200,
                          "delay-on-touch-only": true,
                          "touch-start-threshold": 5
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rocks, (r) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: 'rock' + r.ID,
                                class: "inbox-rk",
                                onClick: ($event: any) => (_ctx.openRock(r))
                              }, [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(r.Name), 1),
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["crm-rock-st", _ctx.rockStatus(r.Status).cls])
                                  }, _toDisplayString(_ctx.rockStatus(r.Status).label), 3),
                                  (r.MilestoneCount)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(r.MilestonesDone) + "/" + _toDisplayString(r.MilestoneCount) + " milestones", 1))
                                    : _createCommentVNode("", true),
                                  (r.TeamRock)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Team Rock"))
                                    : _createCommentVNode("", true)
                                ])
                              ], 8, _hoisted_22))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["list"]),
                        (!_ctx.rocks.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, "No rocks left to add this quarter"))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
        ]),
        (_ctx.rockOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "form-close-x",
                    title: "Close",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.rockOpen = null))
                  }, "×")
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", null, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", {
                      class: "crm-item-label",
                      style: {"margin-top":"0"}
                    }, "Rock", -1)),
                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.rockOpen.rock.Name), 1),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["crm-rock-st", _ctx.rockStatus(_ctx.rockOpen.rock.Status).cls])
                      }, _toDisplayString(_ctx.rockStatus(_ctx.rockOpen.rock.Status).label), 3),
                      (_ctx.rockOpen.rock.MilestoneCount)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.rockOpen.rock.MilestonesDone) + "/" + _toDisplayString(_ctx.rockOpen.rock.MilestoneCount) + " milestones", 1))
                        : _createCommentVNode("", true),
                      (_ctx.rockOpen.rock.TeamRock)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Team Rock"))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "crm-item-label" }, "Add to This Board", -1)),
                    _createElementVNode("div", _hoisted_36, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rockOpen.Column) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: col,
                            value: col
                          }, _toDisplayString(col), 9, _hoisted_37))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.rockOpen.Column]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn",
                        disabled: _ctx.saving || !_ctx.rockOpen.Column,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addRock()))
                      }, "Add to Board", 8, _hoisted_38)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}